import { LinkFloatingToolbar } from '@/components/plate-ui/link-floating-toolbar';

export const linkPlugin = {
  renderAfterEditable: LinkFloatingToolbar,
};